module.exports = __webpack_public_path__ + "static/icon-campaign-4-df571a889479971d7ca8085203df7df1.png";